<agr-dialog (confirm)="save()" (alt)="alt()" (cancel)="cancel()" [data]="data">
  <div class="flex--row">
    <mat-tab-group
      data-test="feed-profit-settings__tabs"
      animationDuration="0"
      color="accent"
      class="settings-tabs"
      [(selectedIndex)]="selectedTabIndex"
      (selectedTabChange)="selectedTabChange($event)"
      [mat-stretch-tabs]="false"
    >
      <mat-tab [label]="'feed-profit.settings.company-details.title' | translate">
        <app-company-details [calculation]="calculation"> </app-company-details>
      </mat-tab>
      <mat-tab [label]="'feed-profit.settings.products.title' | translate">
        <app-baseline
          (baseLineChanged)="calculationSettingsChanged($event)"
          [calculation]="calculation"
        ></app-baseline>
      </mat-tab>
      <mat-tab [label]="'feed-profit.settings.baseline-settings.title' | translate">
        <app-baseline-settings [calculation]="calculation"> </app-baseline-settings>
      </mat-tab>
      <mat-tab [label]="'feed-profit.settings.extended-baseline-settings.title' | translate">
        <app-extended-baseline-settings
          [calculation]="calculation"
        ></app-extended-baseline-settings>
      </mat-tab>
    </mat-tab-group>
  </div>
</agr-dialog>
